
export enum DateType {
    Relative = "relative",
    Absolute = "absolute",
}

export enum DateScale {
    Hour = "h",
    Day = "d",
    Month = "m",
    Year = "y",
    All = "ALL",
}
